import { Grid } from '@mui/material'
import clsx from 'clsx'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
import { IPageHeaderActions, IUpdate } from '@Models/common.model'
import { Controller, useForm } from 'react-hook-form'
import { FormService } from '@Services/form.service'
import * as Redux from 'redux'
import { connect } from 'react-redux'
import ClientProfileActions from '@ClientActions/profile.action'
import { ToastServices } from '@Services/toast.service'
import PasswordField from '@Components/Form/PasswordField/PasswordField'

// static data
const saveAction: IPageHeaderActions = {
    name: 'Save',
    value: 'save',
}

const defaultValues = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
}

interface IChangePassword {
    // redux
    changePassword?: (payload: IUpdate<any>) => Promise<any>
    userId?: string
}

function ChangePassword(props: IChangePassword) {
    // core section
    const { changePassword, userId } = props
    const classesInput = 'reddit-input w-100'
    const {
        control,
        formState: { errors },
        handleSubmit,
    } = useForm({ defaultValues })

    // states section
    const passwordPattern =
        // eslint-disable-next-line no-useless-escape
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/

    // function section

    const onSubmit = (formData: any) => {
        const errMsg = (
            <span>
                Unknown user <br /> Please try again later!
            </span>
        )
        const { oldPassword, newPassword } = formData
        const payload: IUpdate<any> = {
            id: userId || '',
            payload: { oldPassword, newPassword },
        }
        if (!userId) return ToastServices.error(errMsg)
        if (changePassword) changePassword(payload)
    }
    /**
     * handle action component
     * @param action get from header action component
     */
    const handleHeaderActions = (action?: string) => {
        switch (action) {
            case 'save':
                handleSubmit(onSubmit)()
                break
            default:
                break
        }
    }

    // main
    return (
        <form action="">
            <PageHeader
                title="Change password"
                actions={[saveAction]}
                getActions={handleHeaderActions}
            />
            <Grid container spacing={2}>
                <Grid
                    container
                    item
                    md={4}
                    alignItems="stretch"
                    direction="column"
                >
                    <Grid item md={4} className="pt-2">
                        <Controller
                            control={control}
                            name="oldPassword"
                            defaultValue=""
                            rules={{
                                required: true,
                                minLength: 8,
                                pattern: passwordPattern,
                            }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <PasswordField
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="Current Password"
                                    className={clsx(classesInput)}
                                    error={errors?.oldPassword && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'oldPassword',
                                        'Current Password',
                                        errors?.oldPassword?.type === 'pattern'
                                            ? `Current Password at least contain
                                        one upper case,
                                        one lower case,
                                        one digit and one special character`
                                            : 'Current Password should contain 8 characters'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item md={4} className="pt-2">
                        <Controller
                            control={control}
                            name="newPassword"
                            defaultValue=""
                            rules={{
                                required: true,
                                minLength: 8,
                                pattern: passwordPattern,
                            }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <PasswordField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="New Password"
                                    variant="filled"
                                    className={clsx(classesInput)}
                                    error={errors?.newPassword && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'newPassword',
                                        'New Password',
                                        errors?.newPassword?.type === 'pattern'
                                            ? `New Password at least contain 
                                        one upper case, 
                                        one lower case, 
                                        one digit and one special character`
                                            : 'New Password should contain 8 characters'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item md={4} className="pt-2">
                        <Controller
                            control={control}
                            name="confirmPassword"
                            defaultValue=""
                            rules={{
                                required: true,
                                minLength: 8,
                                pattern: passwordPattern,
                            }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <PasswordField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="Confirm Password"
                                    variant="filled"
                                    className={clsx(classesInput)}
                                    error={errors?.confirmPassword && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'confirmPassword',
                                        'Confirm Password',
                                        // eslint-disable-next-line no-nested-ternary
                                        errors?.confirmPassword?.type ===
                                            'pattern'
                                            ? `Confirm Password at least contain 
                                        one upper case, 
                                        one lower case, 
                                        one digit and one special character`
                                            : errors?.confirmPassword?.type ===
                                              'validate'
                                            ? 'Passwords do not match'
                                            : 'Confirm Password should contain 8 characters'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </form>
    )
}

// store section
const mapStateToProps = (store: any) => {
    const userId = store?.auth?.user?.id
    return { userId }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { changePassword } = ClientProfileActions
    return {
        changePassword: (payload: IUpdate<any>) =>
            dispatch(changePassword(payload) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
